import { render, staticRenderFns } from "./select-salesman-subtype.vue?vue&type=template&id=0855dc92"
import script from "./select-salesman-subtype.vue?vue&type=script&lang=js"
export * from "./select-salesman-subtype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports